import {ActivityStreamId} from "platformed-client/types";
import api from "../../api";
import {param, typedQuery} from "../typing";

export const activities = typedQuery(
  ["activities", param<ActivityStreamId>("activityStreamId")],
  async activityStreamId => {
    return await api.activities.list(activityStreamId, {});
  },
);
